import { gql } from "apollo-angular";

export const GET_LEAVES = gql`
  query leaves($filter: LeaveManagementFilter) {
    leaves(filter: $filter) {
    id
    employeeId
    employee {
      id
      firstName
      lastName
      employeeApprovers {
        levelOneData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
         levelTwoData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
         levelThreeData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
        levelFourData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
        levelFiveData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
        levelSixData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
        levelSevenData {
          id
          firstName
          lastName
          leaveApproval{
            id
            comments
          }
        }
      }
      email
    }
    leaveType
    startDate
    endDate
    totalLeaveDays
    leaveStatus
    employeeComment
    supportingDocuments
    createdAt
  }
  }
`;

export const GET_LEAVES_BY_ID = gql`
  query leave($id: Int!) {
    leave(id: $id) {
    id
    employeeId
    employee {
      id
      firstName
      lastName
      middleName
      dateOfBirth
      gender
      designation{
        designationName
      }
      employeeApprovers{
        levelOneData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelTwoData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelThreeData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelFourData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelFiveData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelSixData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
        levelSevenData{
          id
          firstName
          lastName
          profilePicture
          leaveApproval{
            id
            type
            comments
          }
        }
      }
      email
      phoneNumber
      alternatePhoneNumber
      dateOfJoining
      employmentType
      employeeType
      employeeStatus
      profilePicture
      status
    }
    leaveType
    startDate
    endDate
    totalLeaveDays
    leaveStatus
    employeeComment
    supportingDocuments
    createdAt
    updatedAt
    deletedAt
  }
  }
`;

export const GET_LEAVE_COUNT = gql`
  query getLeaveBalance($employeeId: Int!) {
    getLeaveBalance(employeeId: $employeeId) {
    balance
    leaveType
    used
  }
  }
`;

export const LEAVE_APPROVALS = gql`
  query leaveApprovals($requestId: Int!, $type: LeaveApproverTypesEnum!) {
    leaveApprovals(requestId: $requestId, type: $type) {
    id
    type
    requestId
    approverId
    approver {
      id
      firstName
      lastName
      middleName
      dateOfBirth
      gender
      employeeApprovers{
        levelOne
        levelTwo
        levelThree
        levelFour
        levelFive
        levelSix
        levelSeven
      }
      email
      phoneNumber
      alternatePhoneNumber
      address
      permanentAddress
      dateOfJoining
      employmentType
      employeeType
      employeeStatus
      profilePicture
      maritalStatus
      nationality
      passportNumber
      visaType
      visaIssueDate
      visaExpiryDate
      salary
      bankName
      bankAccountNumber
      IFSCCode
      isPortalUser
      departmentId
      designationId
      designation {
       id
       designationName
       status
      }
    }
    vacationRequestData {
      id
      employeeId
      requestDate
      startDate
      endDate
      status
      additionalSalary
    }
    leaveData {
      id
      employeeId
      leaveType
      startDate
      endDate
      totalLeaveDays
      leaveStatus
      employeeComment
      supportingDocuments
      createdAt
      updatedAt
      deletedAt
    }
    approvalStatus
    approvalDate
    comments
    createdAt
    updatedAt
    deletedAt
  }
  }
`;

export const TIMELINES = gql`
  query timelines($type: TimelineTypeEnum, $refId: Int, $activityType: TimelineActivityTypeEnum, $search: String) {
    timelines(type: $type, refId: $refId, activityType: $activityType, search: $search) {
    id
    type
    refId
    activityType
    note
    createdAt
    updatedAt
    deletedAt
  }
  }
`;